/** True on macOS and iOS, where Cmd takes the place of Ctrl/Alt in a few gestures. */
export const IS_MAC: boolean =
  typeof navigator !== 'undefined' &&
  /Mac|iPhone|iPad|iPod/.test(
    (navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData?.platform ?? navigator.platform ?? '',
  );

/** Name of the modifier that drags a copy of the selection. */
export const DUPLICATE_DRAG_KEY = IS_MAC ? 'Cmd' : 'Alt';
